import {Moment} from 'moment-timezone'

export const hasNewUpdates = (updated: Moment, lastVisited: Moment) => {
  return updated.isAfter(lastVisited)
}
